import React, { PropsWithChildren } from 'react';
import Dialog from '@mui/material/Dialog';
import { alpha } from '@mui/material/styles';

interface BlurDialogProps {
  open: boolean;
  disableEscapeKeyDown?: boolean;
  onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  fullWidth?: boolean;
  backgroundColor?: string;
}

const RANGE = 100;

export default function BlurDialog(props: PropsWithChildren<BlurDialogProps>) {
  const transparency = RANGE;

  const backgroundColorProp = props.backgroundColor
    ? alpha(props.backgroundColor, Math.min(1, Math.abs(transparency / RANGE)))
    : 'transparent';

  const { backgroundColor, ...validDomProps } = props;

  return (
    <Dialog
      {...validDomProps}
      disableEnforceFocus
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(10px)',
            backgroundColor: backgroundColorProp,
          },
        },
      }}
      style={{ zIndex: 1500 }}
    />
  );
}
